import { Env } from './services/environment';

export class Config {
  public static BASE_URL = 'tyta.nl/api/v1';
  public static URL = (env: Env) => `https://${env}.${Config.BASE_URL}`;
}
